<template>
  <div id="app">
    <transition name="slide-left">
    <router-view/>
    </transition>
  </div>
</template>

<style lang="scss">
  @import url("https://fonts.googleapis.com/css2?family=Bangers&display=swap");
  @import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans:ital,wght@1,900&display=swap');
  @import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
  $lightBlue : #0095d4;
  .lightblue{
   color: $lightBlue
  }
  .white {
    color: white;
  }
  .grid-active{
    border: 2px solid red !important;
  }
  body {
    background-color: $lightBlue;
  }
  a, a:active, a:visited, a:hover{
    text-decoration: none;
  }
  *:focus {
    outline: none;
  }
  @mixin  shaddow{
    -webkit-box-shadow: 0px 0px 28px 2px rgba(255,255,255,1);
    -moz-box-shadow: 0px 0px 28px 2px rgba(255,255,255,1);
    box-shadow: 0px 0px 28px 2px rgba(255,255,255,1);
  }
  h1{
    font-size: 30px;
    font-family: 'Bangers', 'Alegreya Sans', cursive;
    letter-spacing: 2px;
  }
  h2{
    font-size: 30px;
    font-family: 'Open Sans', sans-serif;
  }

  html, body {
    font-family: 'Open Sans', sans-serif;
    background: url('~@/assets/static/bg_blasen.jpg');
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    height:100%
  }

  #app {
    font-family: 'Open Sans', sans-serif;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    box-sizing: border-box;
  }
  .app__content-wrapper{

    width:100%;
    height: calc(100vh - 100px);
    margin: 0;
    padding: 0;
    padding-top: 2em;
  }

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}
.button-big{
  display: block;
  background-color: $lightBlue;
  padding: 17px;
  text-align: center;
  border-radius: 30px;
  color: white;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  transition:all 0.2s;
  max-width: 300px;
  margin: 0 auto;
  margin-bottom: 1em;
  border: 2px solid white;
  @include shaddow;
  &:hover{
    background-color: white;
    color:$lightBlue
  }

}
  .button-small{
    display: block;
    background-color: $lightBlue;
    padding: 11px;
    text-align: center;
    border-radius: 20px;
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    transition:all 0.2s;
    width: 250px;
    margin: 0 auto;
    margin-bottom: 1em;
    border: 2px solid white;
    @include shaddow;
    &:hover{
      background-color: white;
      color:$lightBlue
    }

  }
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.list-enter,
.list-leave-to {
  visibility: hidden;
  height: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .speech-bubble-edit-button, .speech-bubble-finish-button, .speech-bubble-tail-button{
    position: absolute;
    cursor: pointer;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .speech-bubble-edit-button{

  }

  .speech-bubble-finish-button{
    background: green;
  }

  .speech-bubble-tail-button{

z-index: 30;
    border-radius: 10px;
  }
  .speech-bubble-highlight{
    border:1px solid red;
    position: absolute;



  }
</style>
<script>
import ConsentManager from "@/components/Consent";
export default {
  components: {ConsentManager}
}
</script>
